import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
  selector: "component-user-avatar",
  templateUrl: "./user-avatar.component.html",
  styleUrl: "./user-avatar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[style.width.px]": "size()",
    "[style.height.px]": "size()",
    "[class.user-avatar]": "true"
  }
})
export class UserAvatarComponent {
  readonly user = input<{ avatar?: string | null; username?: string | null; email?: string | null } | null>(null);
  readonly avatarUrl = input<string | null>(null);
  readonly name = input<string | null>(null);
  readonly size = input<number>(32);

  protected readonly finalAvatarUrl = computed(() => {
    return this.avatarUrl() || this.user()?.avatar;
  });

  protected readonly letter = computed(() => {
    const name = this.name() || this.user()?.username || this.user()?.email || " ";
    return name.charAt(0).toUpperCase();
  });

  protected readonly altText = computed(() => {
    return this.name() || this.user()?.username || "User avatar";
  });
}

